import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserService } from './services/user.service';

@Injectable({
  providedIn: 'root',
})
export class CommunityManagerUserGuard {
  constructor(private user: UserService) {}
  canActivate(): Observable<boolean> {
    return this.user.isCommunityManager$;
  }
}